import { Inject } from '@odinjs/odin';
import { AutocompleteAPI, FetchAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnChange, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';

import { FragmentNames, SlaOsListAliases } from '../../codegen';
import BaseController from '../BaseController';

interface Item extends Record<string, Value> {
  label: string;
  value: any;
}

@Controller({ fragment: FragmentNames.SLA_OS_LIST })
export default class SlaGraphicController extends BaseController {

  @Inject(SlaOsListAliases.AUTOCOMPLETE_TYPE)
  autocompleteType!: AutocompleteAPI;

  @Inject(SlaOsListAliases.FETCH_SLA_OS_LIST)
  fetchSlaOsList!: FetchAPI;

  year!: string | number;
  month!: string | number;
  typeSla!: string | number;

  @OnMount(SlaOsListAliases.FETCH_SLA_OS_LIST)
  onMountFetchSlaOsList(): void {
    this.year = this.getPathId('year');
    this.month = this.getPathId('month');
    this.typeSla = this.getPathId('typeSla');
    this.fetchSlaOsList.setParameters({
      year: this.year,
      month: this.month,
      typeSla: this.typeSla,
    });
    this.fetchSlaOsList.forceFetch();
  }

  @OnMount(SlaOsListAliases.AUTOCOMPLETE_TYPE)
  onMountAutocompleteType(): void {
    const data: Item[] = [
      { label: 'sla.delayed-solution-status', value: '2' },
      { label: 'sla.delayed-answer-status', value: '1' },
      { label: 'sla.not-late', value: '0' },
    ];
    this.autocompleteType.setData(data);
  }

  @OnChange(SlaOsListAliases.AUTOCOMPLETE_TYPE)
  onChangeAutocompleteType(event: ChangeEvent<Item[]>): void {
    const status: any[] = [];
    (event.value ?? []).forEach(item => status.push(item.value));
    const params = {
      status,
      month: this.month,
      year: this.year,
      typeSla: this.typeSla,
    };
    this.fetchSlaOsList.setParameters(params);
  }

}
